var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0357 14.3852C19.1424 9.50815 23.504 5.86735 28.7159 5.86735C34.7643 5.86735 39.6674 10.7705 39.6674 16.8189C39.6674 22.4214 35.4604 27.0414 30.0332 27.692M10.7347 10.7347L15.6021 5.86735L10.7347 1M1 15.6021V12.3572C1 8.77293 3.90558 5.86735 7.4898 5.86735H12.3572M32.6378 35.0715L27.7704 39.9388L32.6378 44.8062M42.3725 30.2041V33.449C42.3725 37.0332 39.4669 39.9388 35.8827 39.9388H31.0153M22.9031 31.4209C22.9031 37.4693 17.9999 42.3725 11.9515 42.3725C5.90317 42.3725 1 37.4693 1 31.4209C1 25.3726 5.90317 20.4694 11.9515 20.4694C17.9999 20.4694 22.9031 25.3726 22.9031 31.4209Z",
    stroke: "#00AC4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.6d77273aade956257c5ce89356232333.svg";
export { ForwardRef as ReactComponent };